import React, { Suspense } from "react";
import { LinearProgress } from "@mui/material";
import { Outlet, Navigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    flexGrow: 1,
    maxWidth: "100%",
    overflowX: "hidden",
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56,
    },
  },
}));

function Auth() {
  const classes = useStyles();
  const user = localStorage.getItem("user");
  if (user) {
    return <Navigate to="/dashboard/devices" replace />;
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Suspense fallback={<LinearProgress />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
}

export default Auth;
